import React, { Component } from 'react';
import styles from '../../styles/login.module.css';
import LoginForm from './LoginForm';
import ForgotPassword from '../password/ForgotPassword';
import FirstSetup from '../password/FirstSetup';
import LoginCompany from '../login/LoginCompany';
import LoginChangePassword from '../login/LoginChangePassword';
import { connectApp } from '../../actions/login';
import { generateToken } from '../../actions/authentication';
import Alert from 'react-bootstrap/Alert';
import * as LoginCode from '../../scripts/StatusLoginCode';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import InstallPWA from '../PWA/InstallPWA';
import InstallPWAIOS from '../PWA/InstallPWAIOS';
import InstallPWAFirefox from '../PWA/InstallPWAFirefox';
import * as storage from '../../utils/storage';
import * as cookie from '../../scripts/CookiesAppGo';
import i18n from '../../i18n/i18n';
import AlertAlgo from '../controls/AlertSnack';
import { loadLocalization } from '../../utils/kendoLocalization';
import HelpOnlineButton from '../helpOnline/HelpOnlineButton';
import * as SourcePage from '../../scripts/HelpOnlineSourcePage';
import logo from "../../images/KoneK_logo_2.jpg";
import { log } from '../../actions/error'
import { isIOS } from '../../utils';
import { sessionLogout } from '../../actions/login';

loadLocalization();

class Login extends Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            errorSSO: false,
            errorGeneral: false,
            errorSession: false,
            errorMenu: false,
            errorParam: false,
            errorLogin: false,
            openFirstSetup: false,
            openLoginCompany: false,
            openLoginChangePassword: false,
            companies: [],
            language: 'fr',
            userCode: '',
            version: '',
            isiOS: isIOS(),
            applyAnimation: false,
            showForgotPassword: false,
            listPrefixConnection: [],
            companyTitle: ''
        };
        this.alert = React.createRef();
    }

    componentDidMount() {
        this.loadPage();
    }

    loadPage = async () => {
        await storage.init();

        // Always reset the param � false for security
        storage.saveIsSSO(false);

        //Caching();
        // On loading the login page we always clean the session by security
        sessionLogout();
        this.handleDeleteCache();
        this.logDeviceInfo();
        this.getVersion();
        this.validateLanguage();
        this.resetSession();
        this.validateError();

        this.setState({ companyTitle: storage.getConfigCompanyTitle() });

        setTimeout(() => {
            this.setState({ applyAnimation: true });
        }, 1500);
    }

    logDeviceInfo = () => {
        if (storage.getConfigLogInfoDevice()) {
            const platform = window.navigator.platform;// system operation
            const isMobile = window.navigator.userAgentData.mobile; // check if is mobile device
            const mobSystem = window.navigator.userAgentData.platform; // mob system operation
            const mobVersion = navigator.appVersion; // device version
            const info = `Platform = ${platform} / IsMobile = ${isMobile} / MobSystem = ${mobSystem} / MobVersion = ${mobVersion}`;

            log(info);
        }
    }

    handleDeleteCache = async () => {
        console.log('%cStart delete cache', 'color:red;');
        await caches.keys().then((cacheNames) => {
            return Promise.all(
                cacheNames.map((cache) => {
                    return caches.delete(cache); //Deleting the cache
                })
            );
        })

        const CACHE_NAME = `algo-konekmob-${new Date().getTime()}`;
        const urlsToCache = [
            './js/main.js',
        ];
        const cache = await caches.open(CACHE_NAME);
        await cache.addAll(urlsToCache);
        console.log('%cNew cache installed', 'color:green;');
    }

    getVersion = () => {
        fetch("./meta.json?v=" + new Date().getMilliseconds())
            .then(response => {
                return response.json();
            })
            .then(meta => {
                const version = meta.version;
                this.setState({ version: version });
            });
    }

    validateError = () => {
        if (this.props.match.params.error === "1") {
            this.setState({ errorSession: true })
        } else if (this.props.match.params.error === "2") {
            this.setState({ errorMenu: true })
        } else if (this.props.match.params.error === "3") {
            this.setState({ errorParam: true })
        } else if (this.props.match.params.error === "4") {
            this.setState({ errorGeneral: true, applyAnimation: true })
        } else if (this.props.match.params.error === "5") {
            this.setState({ errorSSO: true, applyAnimation: true })
        } else if (this.props.match.params.error === "999") {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    registration.unregister();
                }
            });
        }
    }

    resetSession = () => {
        const { cookies } = this.props;

        cookies.set(cookie.token_timeout, false, { path: '/' });
    }

    validateLanguage = () => {
        const language = storage.getLanguage();
        if (language === null) {
            storage.saveLanguage("fr");
            i18n.changeLanguage("fr");
            this.setState({ language: "fr" });
        }
        else {
            i18n.changeLanguage(language);
            this.setState({ language: language });
        }
    }

    changeLogo = (language) => {
        this.state.language = language;
    }

    handleErrorLogin = (statusLogin) => {
        if (statusLogin === LoginCode.LOGIN_PASSWORDFIRSTSETUP) {
            this.setState({ openFirstSetup: true });
        }
    }

    handleMultipleCompanies = (companies) => {
        storage.saveCompanies(companies);
        this.setState({
            openLoginCompany: true,
            companies: companies
        })
    }

    handleCloseFirstSetup = () => {
        this.setState({ openFirstSetup: false });
    }

    handleCloseLoginCompany = () => {
        this.setState({ openLoginCompany: false });
    }

    handleOnChangeLoginCompany = async (company) => {
        await generateToken(company);
        this.connect();
    }

    handleCloseLoginChangePassword = (success) => {
        this.setState({ openLoginChangePassword: false });

        if (success === true) {
            this.alert.current.showMessageSuccess(i18next.t('password:success.message.password-saved'));
        }
    }

    handleOpenLoginChangePassword = (userCode) => {
        this.setState({ openLoginChangePassword: true, userCode: userCode });
    }

    handleChangeLanguage = (language) => {
        this.setState({ language: language });
    }

    handleChangeUserCode = (userCode) => {
        this.setState({ userCode: userCode });
    }

    connect = () => {
        connectApp(this.props)
    }

    handleShowForgotPassword = (show) => {
        this.setState({ showForgotPassword: show });
    }

    saveListPrefixConnection = (list) => {
        this.setState({ listPrefixConnection: list });
    }

    render() {
        return (
            <div>
                <div className={`${styles.logo} ${styles.logoAnimation} ${this.state.applyAnimation && styles.logoAnimationFinal}`}>
                    <img src={logo} alt="KoneK Mobile" />
                </div>

                <div className={styles.login_form}>
                    <section className={styles.loginWrapper}>
                        <div className={`${styles.logo}`}>
                            <img src={logo} alt="KoneK Mobile" />
                            {this.state.companyTitle !== '' &&
                                <span className={`${styles.logoSpan}`}>{this.state.companyTitle}</span>
                            }
                        </div>
                        {!this.state.errorLogin && this.state.errorGeneral && <Alert variant="danger">
                            {i18next.t('login:login.validation.error-login')}
                        </Alert>
                        }
                        {!this.state.errorLogin && this.state.errorSSO && <Alert variant="danger">
                            {i18next.t('login:login.validation.error-login-sso')}
                        </Alert>
                        }
                        {!this.state.errorLogin && this.state.errorMenu && <Alert variant="danger">
                            {i18next.t('login:login.validation.not-found-menu')}
                        </Alert>
                        }
                        {!this.state.errorLogin && this.state.errorParam && <Alert variant="danger">
                            {i18next.t('login:login.validation.no-param')}
                        </Alert>
                        }
                        {this.state.errorLogin && <Alert variant="danger">
                            {i18next.t('login:login.validation.error-login')}
                        </Alert>
                        }
                        <LoginForm handleErrorLogin={this.handleErrorLogin}
                            handleMultipleCompanies={this.handleMultipleCompanies}
                            handleChangePassword={this.handleOpenLoginChangePassword}
                            changeParentLogo={this.changeLogo}
                            handleChangeLanguage={this.handleChangeLanguage}
                            connect={this.connect}
                            handleChangeUserCode={this.handleChangeUserCode}
                            handleShowForgotPassword={this.handleShowForgotPassword}
                            saveListPrefixConnection={this.saveListPrefixConnection}
                        />
                        <FirstSetup openFirstSetup={this.state.openFirstSetup} handleClose={this.handleCloseFirstSetup} language={this.state.language} userCode={this.state.userCode} listPrefixConnection={this.state.listPrefixConnection} />
                        <LoginCompany openLoginCompany={this.state.openLoginCompany} handleClose={this.handleCloseLoginCompany} companies={this.state.companies} onChange={this.handleOnChangeLoginCompany} />
                        <LoginChangePassword openLoginChangePassword={this.state.openLoginChangePassword} handleClose={this.handleCloseLoginChangePassword} userCode={this.state.userCode} listPrefixConnection={this.state.listPrefixConnection} />
                        {this.state.showForgotPassword &&
                            <ForgotPassword listPrefixConnection={this.state.listPrefixConnection} />
                        }
                        <InstallPWA />
                        <InstallPWAIOS />
                    </section>

                </div>
                <HelpOnlineButton SourcePage={SourcePage.Source_Login} />
                <div id="divVersion" className={`${styles.divVersion} ${this.state.isiOS && styles.divVersionIOS}`}>
                    {this.state.version}
                </div>
                <AlertAlgo ref={this.alert} />
            </div>
        );
    }
}

export default withNamespaces(['login', 'password'], { wait: true })(withCookies(Login));